module.exports = __webpack_public_path__ + "img/CCWhitewithBrown.f5a0229d.png";